export default __webpack_public_path__ + "static/media/fNeutral10.341e8028.png";